import React from 'react'
import DatePicker from 'react-datepicker'
import { format, isValid, parse } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'
import { PickerFieldShell } from './PickerFieldShell'

interface TimePickerFieldProps {
  id?: string
  value: string
  onChange: (value: string) => void
  minTime?: string
  maxTime?: string
  // PLA-3423: false desabilita o horário (ex.: ocupado por reserva aprovada). Recebe "HH:mm".
  filterTime?: (time: string) => boolean
  isInvalid?: boolean
  placeholder?: string
}

const parseTime = (value: string | undefined): Date | null => {
  if (!value) return null
  const parsed = parse(value, 'HH:mm', new Date())
  return isValid(parsed) ? parsed : null
}

export const TimePickerField = ({
  id,
  value,
  onChange,
  minTime,
  maxTime,
  filterTime,
  isInvalid,
  placeholder = 'HH:MM',
}: TimePickerFieldProps): JSX.Element => {
  const selected = parseTime(value)
  const effectiveMinTime = parseTime(minTime) ?? parse('00:00', 'HH:mm', new Date())
  const effectiveMaxTime = parseTime(maxTime) ?? parse('23:30', 'HH:mm', new Date())

  const handleChange = (date: Date | null, close: () => void): void => {
    if (date != null) {
      onChange(format(date, 'HH:mm'))
      close()
    }
  }

  return (
    <PickerFieldShell
      id={id}
      value={value}
      displayValue={value}
      placeholder={placeholder}
      isInvalid={isInvalid}
      icon={<FontAwesomeIcon icon={faClock} fontSize={16} />}
    >
      {close => (
        <DatePicker
          locale={ptBR}
          selected={selected}
          onChange={date => handleChange(date, close)}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={30}
          timeCaption="Hora"
          dateFormat="HH:mm"
          timeFormat="HH:mm"
          minTime={effectiveMinTime}
          maxTime={effectiveMaxTime}
          filterTime={filterTime ? time => filterTime(format(time, 'HH:mm')) : undefined}
          inline
        />
      )}
    </PickerFieldShell>
  )
}
